import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';

const BucketStatistics = ({ bucketStats, currency }) => {
    return (
        <div className="bg-white border border-[#6D9773]/20 rounded-lg shadow-sm p-6 text-[#0C3B2E]">
            <h3 className="text-lg font-medium text-[#6D9773] mb-4">Bucket Statistics</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                    <h4 className="text-md font-medium">All Time</h4>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-sm font-medium text-gray-600">Revenue per Bucket</p>
                            <p className="text-xl font-semibold">
                                {formatCurrency(bucketStats?.allTime?.averages?.revenuePerBucket || 0, currency)}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-600">Variations per Bucket</p>
                            <p className="text-xl font-semibold">{bucketStats?.allTime?.averages?.variationsPerBucket || '0.00'}</p>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-600">Images per Bucket</p>
                            <p className="text-xl font-semibold">{bucketStats?.allTime?.averages?.imagesPerBucket || '0.00'}</p>
                        </div>
                    </div>
                </div>
                <div className="space-y-4">
                    <h4 className="text-md font-medium">Last 30 Days</h4>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-sm font-medium text-gray-600">Revenue per Bucket</p>
                            <p className="text-xl font-semibold">
                                {formatCurrency(bucketStats?.last30Days?.averages?.revenuePerBucket || 0, currency)}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-600">Variations per Bucket</p>
                            <p className="text-xl font-semibold">{bucketStats?.last30Days?.averages?.variationsPerBucket || '0.00'}</p>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-600">Images per Bucket</p>
                            <p className="text-xl font-semibold">{bucketStats?.last30Days?.averages?.imagesPerBucket || '0.00'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BucketStatistics;